import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { MatLegacyCardModule } from "@angular/material/legacy-card";
import { CtButtonModule } from "@ctsolution/ct-framework";
import { FlexLayoutModule, FlexModule } from "@angular/flex-layout";
import {
  VariableFieldsManagerModule
} from "../../../../_components/flow-components/editor/variable-fields-manager/variable-fields-manager.module";
import { MatIconModule } from "@angular/material/icon";
import { MatLegacyCheckboxModule } from "@angular/material/legacy-checkbox";
import { MatLegacyDialogModule } from "@angular/material/legacy-dialog";
import { PaginatorModule } from "primeng/paginator";
import { ReactiveFormsModule } from "@angular/forms";
import { TextFieldModule } from "@angular/cdk/text-field";
import { AddressBookSaveModule } from "../address-book-save/address-book-save.module";
import { AddressBookDetailComponent } from "./address-book-detail.component";

import { MatLegacyButtonModule as MatButtonModule } from "@angular/material/legacy-button";
import { MatLegacyDialogModule as MatDialogModule } from "@angular/material/legacy-dialog";

@NgModule({
  imports: [
    CommonModule,
    AddressBookSaveModule,
    MatLegacyCardModule,
    CtButtonModule,
    FlexModule,
    VariableFieldsManagerModule,
    MatIconModule,
    MatLegacyCheckboxModule,
    MatLegacyDialogModule,
    PaginatorModule,
    ReactiveFormsModule,
    TextFieldModule,
    FlexLayoutModule,
    MatButtonModule,
    MatDialogModule
  ],
  declarations: [AddressBookDetailComponent],
  exports: [AddressBookDetailComponent]
})
export class AddressBookDetailModule { }
